import { useEffect } from 'react';
import { useFieldValue } from '@atlassian/jira-issue-field-base/src/services/field-value-service/index.tsx';
import { PRIORITY_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import { useDiffCheck } from '../../../../common/hooks/use-diff-check/index.tsx';
import type { Card } from '../../../../model/types.tsx';
import { cardPrioritySet } from '../../../../state/actions/priorities/index.tsx';
import { useBacklogActionCreator } from '../../../../state/index.tsx';

type Props = {
	card: Card;
};

export const FieldSyncPriority = ({ card: { id, key, priority: priorityFromBacklog } }: Props) => {
	const setPriorityInBacklog = useBacklogActionCreator(cardPrioritySet);
	const [priorityFromExtractedField, { setFieldValue: setPriorityInExtractedField }] =
		useFieldValue({
			issueKey: key,
			fieldKey: PRIORITY_TYPE,
		});

	const priorityFromBacklogChanged = useDiffCheck([priorityFromBacklog?.name]);
	const priorityFromExtractedFieldChanged = useDiffCheck([priorityFromExtractedField?.name]);

	const storesNeedToSync = priorityFromBacklog !== priorityFromExtractedField;

	useEffect(() => {
		const priorityFromBacklogIsDefined = priorityFromBacklog !== undefined;

		if (priorityFromBacklogIsDefined && priorityFromBacklogChanged && storesNeedToSync) {
			setPriorityInExtractedField(key, PRIORITY_TYPE, priorityFromBacklog);
		}
	}, [
		key,
		priorityFromBacklogChanged,
		storesNeedToSync,
		setPriorityInExtractedField,
		priorityFromBacklog,
	]);

	useEffect(() => {
		const priorityFromExtractedFieldIsDefined = priorityFromExtractedField !== undefined;

		if (
			!priorityFromBacklogChanged &&
			priorityFromExtractedFieldIsDefined &&
			priorityFromExtractedFieldChanged &&
			storesNeedToSync
		) {
			setPriorityInBacklog({
				cardId: id,
				priority: priorityFromExtractedField,
			});
		}
	}, [
		id,
		priorityFromBacklogChanged,
		priorityFromExtractedField,
		priorityFromExtractedFieldChanged,
		storesNeedToSync,
		setPriorityInBacklog,
	]);

	return null;
};

export default FieldSyncPriority;
